export default __webpack_public_path__ + "static/media/gel-container.ac5967e1.svg";